import { intoArray } from '@eflexsystems/ramda-helpers';
import { flow, last, filter, gte, sort, uniq, __ } from 'ramda';

export default function (nums, min = 1, maxAllowed = null) {
  min = Number.parseInt(min);

  nums = flow(nums, [
    intoArray(
      filter(gte(__, min)),
      uniq(),
    ),
    sort((a, b) => a - b),
  ]);

  if (maxAllowed != null && nums.length === maxAllowed - min) {
    return;
  }

  const max = Number.parseInt(last(nums));

  let i;

  for (i = min; i <= max; i++) {
    if (nums[i - min] !== i) {
      break;
    }
  }

  return i;
}
